
import { defineComponent } from 'vue';

import MaterialIcon from '@/components/MaterialIcon.vue';

export default defineComponent({
  name: 'LinkIcon',

  components: {
    MaterialIcon
  },

  props: {
    href: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    text: String,
    iconBefore: String,
    iconAfter: String,
    isExternal: Boolean
  }
});
